// extracted by mini-css-extract-plugin
export var copyright = "Copyright-module--copyright--e6e80";
export var layout = "Copyright-module--layout--7faad";
export var link = "Copyright-module--link--615a5";
export var socialSection = "Copyright-module--socialSection--4f418";
export var text = "Copyright-module--text--1bf36";
export var textSection = "Copyright-module--textSection--2fa3f";
export var wrapper = "Copyright-module--wrapper--5ba3c";